import request from '../utils/request';
const querystring = require('querystring')
//获取列表数据
export const fetchData = query => { 
    query.secret = localStorage.getItem('ms_secret');
    query.mid = localStorage.getItem('ms_mid');
    query.my = '1';
    var list = request({
        url: 'haoka/hkWo/selectPage.do',
        method: 'post',
        params: query
    }); 
    return list;
};
export const fetchData2 = query => { 
    query.secret = localStorage.getItem('ms_secret');
    query.mid = localStorage.getItem('ms_mid'); 
    var list = request({
        url: 'haoka/hkWo/selectPage.do',
        method: 'post',
        params: query
    }); 
    return list;
};
export const saveForm = query => { 
    query.secret = localStorage.getItem('ms_secret');
    query.mid = localStorage.getItem('ms_mid');
    var list = request({
        url: 'haoka/hkWo/insert.do',
        method: 'post',
        data: querystring.stringify(query), 
    }); 
    return list;
};
//关闭订单
export const handDelete = query => { 
    query.secret = localStorage.getItem('ms_secret');
    query.mid = localStorage.getItem('ms_mid');
    var list = request({
        url: 'haoka/hkWo/update.do',
        method: 'post',
        params: query
    }); 
    return list;
};
//查询回复记录 
export const getReplayList = query => { 
    query.secret = localStorage.getItem('ms_secret');
    query.mid = localStorage.getItem('ms_mid');
    query.my = '1';
    var list = request({
        url: 'haoka/hkWoReply/selectList.do',
        method: 'post',
        data: querystring.stringify(query), 
    }); 
    return list;
};

//回复
export const replyForm = query => { 
    query.secret = localStorage.getItem('ms_secret');
    query.mid = localStorage.getItem('ms_mid');
    var list = request({
        url: 'haoka/hkWoReply/insert.do',
        method: 'post',
        data: querystring.stringify(query), 
    }); 
    return list;
};





